
















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TypeformForm } from '@/api/model/typeform/typeform-form'
import { TypeformLogicJump } from '@/api/model/typeform/typeform-logic-jump'
import { TypeformLogicJumpAction } from '@/api/model/typeform/typeform-logic-jump-action'
import { TypeformLogicJumpCondition } from '@/api/model/typeform/typeform-logic-jump-condition'
import { TypeformLogicJumpFlattenedCondition } from '@/api/model/typeform/typeform-logic-jump-flattened-condition'
import { TypeformReferenceRegExp } from '@/api/model/typeform/typeform-form'
import LogicJumpPopOutCondition from '@/views/Company/Settings/Typeform/Forms/Detail/LogicJumpPopOutCondition.vue'
import { cloneDeep, isEqual } from 'lodash'

@Component({
    components: {
        LogicJumpPopOutCondition,
    },
})
export default class LogicJumpPopOutAction extends Vue {
    @Prop({ required: true }) readonly form!: TypeformForm
    @Prop({ required: true }) readonly logicJump!: TypeformLogicJump
    @Prop({ required: true }) readonly action!: TypeformLogicJumpAction
    @Prop({ required: true }) readonly actionIndex!: number
    internalAction: TypeformLogicJumpAction = null
    internalConditions: TypeformLogicJumpFlattenedCondition[] = []
    deleteHover: boolean = false

    @Watch('action', { immediate: true })
    onActionChanged() {
        if (!isEqual(this.internalAction, this.action)) {
            this.internalAction = cloneDeep(this.action)
            this.internalConditions = cloneDeep(this.action.flattenedConditions)
        }
    }

    @Watch('internalAction', { deep: true })
    onInternalActionChanged() {
        if (isEqual(this.internalAction, this.action)) {
            return
        }

        this.$emit('update:action', this.internalAction)
    }

    @Watch('internalConditions', { deep: true })
    onInternalConditionsChanged() {
        if (isEqual(this.internalConditions, this.internalAction.flattenedConditions)) {
            return
        }

        this.internalAction.flattenedConditions = this.internalConditions
    }

    get to(): string|null {
        if (this.internalAction.details.to.type === null) {
            return null
        }

        return this.internalAction.details.to.type + '-' + this.internalAction.details.to.value
    }

    set to(to: string|null) {
        let type = null
        let value = null

        if (to !== null) {
            const toParts = to.split('-')
            type = toParts.shift()
            value = toParts.join('-')
        }

        this.internalAction.details.to = { type, value }
    }

    get toOptions() {
        const toOptions = []

        this.form.fields.forEach(field => {
            if (this.logicJump.type === 'field' && this.logicJump.ref === field.ref) {
                return
            }

            toOptions.push({
                label: field.title.replaceAll(TypeformReferenceRegExp, '_'),
                value: 'field-' + field.ref,
            })
        })

        this.form.thankyou_screens.forEach(thankyou_screen => {
            toOptions.push({
                label: thankyou_screen.title.replaceAll(TypeformReferenceRegExp, '_'),
                value: 'thankyou-' + thankyou_screen.ref,
            })
        })

        return toOptions
    }

    get canAddCondition(): boolean {
        if (this.internalAction.alwaysCondition) {
            return false
        }

        return true
    }

    onAddCondition() {
        const condition = TypeformLogicJumpFlattenedCondition.fromCondition(
            TypeformLogicJumpCondition.fromData({
                op: null,
                vars: [
                    { type: null, value: null },
                    { type: null, value: null },
                ],
            }),
            'and',
        )

        this.internalConditions.splice(this.internalConditions.length, 0, condition)
    }

    onDeleteCondition(condition: TypeformLogicJumpFlattenedCondition, conditionIndex: number): void {
        this.internalConditions.splice(conditionIndex, 1)
    }

    get isDeletable(): boolean {
        if (this.internalAction.alwaysCondition) {
            return false
        }

        return true
    }

    onDelete() {
        this.$emit('delete')
    }
}
